import {
  SEARCHING,
  SEARCH_FAILURE,
  SEARCH_SUCCESS,
  SEARCH_EMPTY,
  SEARCH_ACTIVEVIEW,
  SEARCH_SET_SELECT,
  SEARCH_UNSET_SELECT,
  SEARCH_EDIT,
  SEARCH_EDIT_SELECT,
  SEARCH_EDIT_UNSET_SELECT,
  SEARCH_EDIT_SUCCESS,
  SEARCH_EDIT_FAILURE,
  SEARCH_EXPAND_SELECT,
  SEARCH_EXPAND_UNSET_SELECT,
  SEARCH_SHARE_SELECT,
  SEARCH_SHARE_UNSET_SELECT,
  SEARCH_DELETE,
  SEARCH_DELETE_SUCCESS,
  SEARCH_DELETE_FAILURE,
  SEARCH_MOVE,
  SEARCH_MOVE_SUCCESS,
  SEARCH_MOVE_FAILURE,
  ASSET_SEARCH_CHECK_SELECT,
  ASSET_SEARCH_UNCHECK_SELECT,
  MULTIPLE_SEARCH_OPTIONS_ACTIVATE,
  MULTIPLE_SEARCH_OPTIONS_DEACTIVATE,
  MULTIPLE_SEARCH_OPTIONS_DONE,
  GO_TO_PAGE,
  IS_SEARCH_ADVANCED,
  ASSETS_SEARCH_MULTI_DELETE,
  ASSETS_SEARCH_MULTI_DELETE_SUCCESS,
  ASSETS_SEARCH_MULTI_DELETE_FAILURE,
  ASSETS_SEARCH_MULTI_MOVE,
  ASSETS_SEARCH_MULTI_MOVE_SUCCESS,
  ASSETS_SEARCH_MULTI_MOVE_FAILURE,
  CLEAN_DATA_BACK_SEARCH,
  SCROLL_SEARCH
} from '../constants/search-types'
import BunkeyAPI from '../api/BunkeyAPI'
import store from '../store'
import { MAX_PAG_SIZE } from '../utils/index'
import { sendNotification, permissionsDefault } from '../utils'


export const cleanDataBackSearch = () => {
  return dispatch => {
    dispatch({
      type: CLEAN_DATA_BACK_SEARCH,
    })
  }
}
export const scrollSearch = (isShow,page) => {
  return dispatch => {
    dispatch({
      type: SCROLL_SEARCH,
      payload: {
        showScrolling: isShow,
        pageScrolling: page
      },
    })
  }
}

export const setSearchEmpty = () => {
  return dispatch => {
    dispatch({ type: SEARCH_EMPTY });
  };
};

export const getSearchResult = (
  workclient,
  newSearchText,
  searchType,
  page = 1,
  order,
  asset = null,
  newLimit = 1000,
  data = []
) => {
  const isFetching = true 
  const { orderBy, } = store.getState().searcher;
  const filterOrder = order !== orderBy && order && order !== "" ? order : orderBy;
  // const pageToGo = searchText !== newSearchText || limit !== newLimit ? 1 : page;

  return dispatch => {
    dispatch({
      type: IS_SEARCH_ADVANCED,
      payload: {
        isAdvancedSearchActive: false,
        isAdvancedSearching: false,
        advancedSearchValues: ""
      }
    })
    // dispatch(goToPage(pageToGo))
    dispatch({ 
      type: SEARCHING,
      payload: { 
        // limit: newLimit 
        isFetching: data.length === 0 ? isFetching : false,
        data,
        isLoadingScroll: data.length !== 0 ? true : false,
      } 
    })

    BunkeyAPI({
      url: !asset
        ? `clients/${workclient}/searcher?q=${newSearchText}&type=${searchType === '' ? 'all' : searchType}&page=${page}&limit=${newLimit || MAX_PAG_SIZE}&orderBy=${filterOrder}`
        : `clients/${workclient}/searcher?asset=${asset}`,
      method: "GET"
    })
      .then(resp => {
        dispatch({
          type: SEARCH_SUCCESS,
          payload: {
            page,
            limit: newLimit,
            searchText: newSearchText.trim(),
            searchType: searchType === "" ? "all" : searchType,
            orderBy: filterOrder,
            data: resp.data
              .filter(r =>
                ["folder", "document", "image", "video"].includes(r.type)
              )
              .map(r => {
                return {
                  _id: r._id,
                  type: r.type,
                  name: r.name,
                  lowQualityURL: r.lowQualityURL,
                  mediaQualityURL: r.mediaQualityURL,
                  originalURL: r.originalURL,
                  metadata: r.metadata,
                  parents: r.parents,
                  createdAt: r.createdAt,
                  group: r.group,
                  user:
                    r.user && r.username
                      ? { id: r.user, name: r.username }
                      : { id: "", name: "" },
                  isShared: r.isShared,
                  objectGroups: r.objectGroup,
                  fileSizeFormat: r.fileSizeFormat,
                  documentPages: r.documentPages,
                  matrix: permissionsDefault().map(def => {
                    const exists = r.group.find(r =>
                      r.permissions.find(
                        item =>
                          item.action === def.action && item.enabled === true
                      )
                    );
                    return {
                      action: def.action,
                      enabled: exists ? true : false
                    };
                  })
                };
              }),
            headers: resp.headers
          }
        });
      })
      .catch(err => {
        dispatch({
          type: SEARCH_FAILURE,
          payload: {
            newSearchText,
            searchType: searchType === "" ? "all" : searchType,
            error: err
          }
        });
      });
  };
};

export const getAdvancedSearchResult = (
  workclient,
  values,
  page,
  order,
  newLimit = 1000, 
  data = []
) => {
  const isFetching = true 
  const { orderBy } = store.getState().searcher
  const filterOrder = (order !== orderBy && order && order !== '') ? order : orderBy
  // const pageToGo = limit !== newLimit ? 1 : page

  return dispatch => {
    dispatch({
      type: IS_SEARCH_ADVANCED,
      payload: {
        isAdvancedSearchActive: true,
        isAdvancedSearching: true,
        advancedSearchValues: values
      }
    })
    // dispatch(goToPage(pageToGo))
    dispatch({ 
      type: SEARCHING,
      payload: {
        // limit: newLimit
        isFetching: data.length === 0 ? isFetching : false,
        data,
        isLoadingScroll: data.length !== 0 ? true : false,
      }
    })
    BunkeyAPI({
      url: `clients/${workclient}/advanced-searcher?${values}&page=${page}&limit=${newLimit || MAX_PAG_SIZE}&orderBy=${filterOrder}`,
      method: 'GET'
    }).then(resp => {
      dispatch({
        type: SEARCH_SUCCESS,
        payload: {
          page,
          limit: newLimit,
          searchText: '',
          searchType: 'all',
          orderBy: filterOrder,
          data: resp.data
            .map(r => {
              return {
                _id: r._id,
                type: r.type,
                name: r.name,
                lowQualityURL: r.lowQualityURL,
                mediaQualityURL: r.mediaQualityURL,
                originalURL: r.originalURL,
                metadata: r.metadata,
                parents: r.parents,
                createdAt: r.createdAt,
                group: r.group,
                user:
                  r.user && r.username
                    ? { id: r.user, name: r.username }
                    : { id: "", name: "" },
                objectGroups: r.objectGroup,
                fileSizeFormat: r.fileSizeFormat,
                documentPages: r.documentPages,
                uuid: r.uuid,
                matrix: permissionsDefault().map(def => {
                  const exists = r.group.find(r =>
                    r.permissions.find(
                      item =>
                        item.action === def.action && item.enabled === true
                    )
                  );
                  return {
                    action: def.action,
                    enabled: exists ? true : false
                  };
                })
              };
            }),
            headers: resp.headers
          }
        });
    }).catch(err => {
      dispatch({
        type: SEARCH_FAILURE,
        payload: {
          // newSearchText,
          // searchType: searchType === '' ? 'all' : searchType,
          error: err
        }
      })
    })
  }
}

export const setSearchActiveView = view => {
  return dispatch => {
    dispatch({
      type: SEARCH_ACTIVEVIEW,
      payload: {
        activeView: view
      }
    });
  };
};

export const setSelectSearcher = (
  item,
  indice,
  from,
  verticalCount,
  horizontalCount
) => {
  return dispatch => {
    dispatch({
      type: SEARCH_SET_SELECT,
      payload: {
        data: item,
        indice,
        from,
        verticalCount,
        horizontalCount
      }
    });
  };
};

export const unsetSelectSearcher = () => {
  return dispatch => {
    dispatch({ type: SEARCH_UNSET_SELECT });
  };
};

export const setEditSearchAsset = (workclient, asset) => {
  return dispatch => {
    dispatch({ type: SEARCH_EDIT });
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${asset._id}`,
      method: "PUT",
      data: {
        _id: asset._id,
        name: asset.name,
        metadata: {
          descriptiveTags: asset.metadata.descriptiveTags,
          createdDate: asset.metadata.createDate,
          dueDate: asset.metadata.dueDate
        }
      }
    })
      .then(resp => {
        dispatch({
          type: SEARCH_EDIT_SUCCESS,
          payload: {
            data: asset,
            headers: resp.headers
          }
        });
      })
      .catch(err => {
        dispatch({
          type: SEARCH_EDIT_FAILURE,
          payload: err
        });
      });
  };
};

export const setSelectEditSearchAsset = (asset, editAssetTab) => {
  return dispatch => {
    dispatch({
      type: SEARCH_EDIT_SELECT,
      payload: {
        data: asset,
        editAssetTab
      }
    });
  };
};

export const unsetSelectEditSearchAsset = () => {
  return dispatch => {
    dispatch({
      type: SEARCH_EDIT_UNSET_SELECT
    });
  };
};

export const setSelectExpandSearchAsset = asset => {
  return dispatch => {
    dispatch({
      type: SEARCH_EXPAND_SELECT,
      payload: {
        data: asset
      }
    });
  };
};

export const unsetSelectExpandSearchAsset = () => {
  return dispatch => {
    dispatch({
      type: SEARCH_EXPAND_UNSET_SELECT
    });
  };
};

export const setSelectShareSearchAsset = asset => {
  return dispatch => {
    dispatch({
      type: SEARCH_SHARE_SELECT,
      payload: {
        data: asset
      }
    });
  };
};

export const unsetSelectShareSearchAsset = () => {
  return dispatch => {
    dispatch({
      type: SEARCH_SHARE_UNSET_SELECT
    });
  };
};

export const deleteSearchAsset = (workclient, id, intl, multiple) => {
  return dispatch => {
    dispatch({ type: SEARCH_DELETE });
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${id}`,
      method: "DELETE"
    })
      .then(resp => {
        dispatch({
          type: SEARCH_DELETE_SUCCESS,
          payload: {
            workclient,
            id
          }
        });
        // if (multiple) {
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "asset_has_been_deleted" })
        );
        // }
      })
      .catch(err => {
        dispatch({
          type: SEARCH_DELETE_FAILURE,
          payload: {
            workclient,
            id,
            error: err
          }
        });
        // if (multiple) {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "error_deleting_asset" })
        );
        // }
      });
  };
};

export const moveSearchAsset = (workclient, asset, folder, intl, multiple) => {
  return dispatch => {
    dispatch({ type: SEARCH_MOVE });
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${asset._id}`,
      method: "PUT",
      data: {
        action: "move",
        folder: folder
      }
    })
      .then(resp => {
        dispatch({
          type: SEARCH_MOVE_SUCCESS,
          payload: {
            data: asset,
            headers: resp.headers
          }
        });
        const {
          searchText,
          searchType,
          orderBy,
          page,
          limit
        } = store.getState().searcher;
        dispatch(
          getSearchResult(
            workclient,
            searchText,
            searchType,
            page,
            orderBy,
            null,
            limit
          )
        );

        // if (multiple) {
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "asset_has_been_moved" })
        );
        // }
      })
      .catch(err => {
        dispatch({
          type: SEARCH_MOVE_FAILURE,
          payload: err
        });
        sendNotification(
          "error",
          intl,
          `${intl.formatMessage({ id: "the_asset" })} ${
            asset.name
          } ${intl.formatMessage({ id: "could_not_move" })}`
        );
      });
  };
};

export const setCheckSearcherAsset = asset => {
  return dispatch => {
    dispatch({
      type: ASSET_SEARCH_CHECK_SELECT,
      payload: asset
    });
  };
};
export const unsetCheckSearcherAsset = asset => {
  return dispatch => {
    dispatch({
      type: ASSET_SEARCH_UNCHECK_SELECT,
      payload: asset
    });
  };
};

export const activateSearchOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_SEARCH_OPTIONS_ACTIVATE
    });
  };
};

export const deactivateSearchOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_SEARCH_OPTIONS_DEACTIVATE
    });
  };
};

export const isDoneMultipeSearchOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_SEARCH_OPTIONS_DONE
    });
  };
};

export const goToPage = page => {
  return dispatch => {
    dispatch({
      type: GO_TO_PAGE,
      payload: {
        page: page
      }
    });
  };
};
export const multiDeleteSearchAsset = (workclient, intl, items) => {
  return dispatch => {
    dispatch({ type: ASSETS_SEARCH_MULTI_DELETE });
    BunkeyAPI({
      url: `/clients/${workclient}/objects-deletemany`,
      method: "PUT",
      data: {
        data: items
      }
    })
      .then(resp => {
        dispatch({
          type: ASSETS_SEARCH_MULTI_DELETE_SUCCESS,
          payload: {
            workclient,
            ids: items
          }
        });
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "assets_has_been_deleted" })
        );
      })
      .catch(err => {
        dispatch({
          type: ASSETS_SEARCH_MULTI_DELETE_FAILURE,
          payload: {
            workclient,
            ids: items,
            error: err
          }
        });
        sendNotification(
          "error",
          intl,
          `${intl.formatMessage({ id: "assets_has_not_been_deleted" })}`
        );
      });
  };
};
export const moveMultiselectSearchAsset = (workclient, ids, folder, intl) => {
  return dispatch => {
    dispatch({ type: ASSETS_SEARCH_MULTI_MOVE });
    BunkeyAPI({
      url: `/clients/${workclient}/objects-movemany/${folder}`,
      method: "PUT",
      data: {
        data: ids
      }
    }).then(resp => {
      dispatch({
        type: ASSETS_SEARCH_MULTI_MOVE_SUCCESS,
        payload: {
          ids: ids,
          headers: resp.headers
        }
      })
      // if (multiple) {
      sendNotification('success', intl, intl.formatMessage({ id: 'assets_have_been_moved' }))
      // }
    }).catch(err => {
      dispatch({
        type: ASSETS_SEARCH_MULTI_MOVE_FAILURE,
        payload: err
      })
      sendNotification('error', intl, `${intl.formatMessage({ id: 'assets_could_not_moved' })}`)
    })
  }
}
